import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ProgramService } from '../../../../services/program.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { NotificationsService } from 'angular2-notifications';
import { ClubProgram } from '../../../../store';
import { CommonService } from '../../../../services';

@Component({
  selector: 'app-tryout-program-update',
  templateUrl: './tryout-program-update.component.html',
  styleUrls: ['./tryout-program-update.component.css']
})
export class TryoutProgramUpdateComponent implements OnInit {
  public clubProgram: ClubProgram;
  public program_id;
  public registration_open_date_value: string;
  public registration_close_date_value: string;
  public programStatusValue: string;
  public isArchive: string;
  public alphaNumericPattern: RegExp;
  public alphaDashSpaceRegex: RegExp;
  public clubEditForm: FormGroup;
  public validationMessages = {};
  public minDate: Date = new Date();

  isPublic: boolean;

  constructor(private notificationsService: NotificationsService,
    private spinnerService: Ng4LoadingSpinnerService,
    private fb: FormBuilder,
    private programService: ProgramService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router) {

    this.alphaDashSpaceRegex = /^[a-z0-9_ \-]+$/i;
    this.isArchive = '0';
    this.programStatusValue = '1';

    this.validationMessages = {
      'ProgramNameRequired': 'Please enter program name.',
      'RegistrationOpenDateRequired': 'Please select registration open date.',
      'RegistrationCloseDateRequired': 'Please select registration close date.',
      'AlphaDashSpace': 'This field must only contain alpha-numeric characters, underscores, dashes and space.',
    };
  }

  ngOnInit() {
    this.program_id = this.route.snapshot.paramMap.get('id');
    this.initForm();
    this.fillProgramForm();
  }

  initForm() {
    this.clubEditForm = this.fb.group({
      program_name: ['', [Validators.required, Validators.pattern(this.alphaDashSpaceRegex)]],
      description: [''],
      registration_open_date: [null, Validators.required],
      registration_close_date: [null, Validators.required],
      activeInactive: '',
      isPublicProgram: '',
      isArchive: [this.isArchive],
      redirectLink: ['', Validators.pattern(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi)],
      allowParentToEditQuestion: [0, Validators.required]
    }, {
      validator: this.dateLessThan('registration_open_date', 'registration_close_date')
    });
  }

  fillProgramForm() {
    this.spinnerService.show();
    this.programService.getProgram(this.program_id).subscribe((data: ClubProgram) => {
      this.clubEditForm.patchValue({
        program_name: data.name,
        description: data.description,
        registration_open_date: data.regstartdate.toString(),
        registration_close_date: data.regenddate.toString(),
        activeInactive: (data.programstatus).toString(),
        isPublicProgram: (data.public).toString(),
        isArchive: this.isArchive,
        redirectLink: data.redirectLink,
        allowParentToEditQuestion: data.allowParentToEditQuestion || 0
      });
      this.isPublic = !!data.public;
      this.spinnerService.hide();
    });
  }

  removeWhiteSpace(f) {
    const value = f.value;
    if (value.program_name === null || value.program_name === '') {
      return false;
    }
  }

  removeWhiteSpaceDescription(f) {
    const value = f.value;
    if (value.description === null || value.description === '') {
      return false;
    }
  }

  dateLessThan(registration_open_date: string, registration_close_date: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const o = group.controls[registration_open_date];
      const c = group.controls[registration_close_date];
      if (o.value > c.value) {
        return {
          regRangeDates: '"To Date" cannot be before "The From Date".'
        };
      }
    };
  }

  validateUi() {
    Object.keys(this.clubEditForm.controls).forEach(field => {
      const control = this.clubEditForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  isInvalid(control: string) {
    return this.clubEditForm.get(control).errors
      && (this.clubEditForm.get(control).touched
        || this.clubEditForm.get(control).dirty);
  }

  copyProgram() {

    const selectionBox = document.createElement('textarea');
    selectionBox.style.position = 'fixed';
    selectionBox.style.left = '0';
    selectionBox.style.top = '0';
    selectionBox.style.opacity = '0';
    selectionBox.value = String(this.isPublic ? `https://parentportal.totalglobalsports.com/tryout-registration/${this.program_id}/player` : this.program_id);
    document.body.appendChild(selectionBox);
    selectionBox.focus();
    selectionBox.select();
    document.execCommand('copy');
    document.body.removeChild(selectionBox);

    this.commonService.alertMessage({ type: 'success', message: 'Direct Program link copied' });
  }

  onSave(event, clubEditForm) {
    event.stopPropagation();
    if (clubEditForm === 'VALID') {
      const f = this.clubEditForm.value;
      const obj = {
        ClubprogramID: this.program_id,
        Name: f.program_name,
        Description: f.description,
        Regstartdate: f.registration_open_date,
        Regenddate: f.registration_close_date,
        Regstatus: 2,
        Programstatus: f.activeInactive,
        Public: f.isPublicProgram,
        RedirectLink: f.redirectLink,
        AllowParentToEditQuestion: f.allowParentToEditQuestion
      };
      event.target.innerHTML = 'Updating <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.programService.updateProgram(obj).subscribe(data => {
        event.target.innerHTML = '<i class="fa fa-pencil push-5-r"></i> Update Program';
        event.target.disabled = false;
        const toast = this.notificationsService.success('success', 'Program successfully updated.', {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: false
        });
        if (f.activeInactive === '0') {
          this.router.navigate(['tryoutprogram/inactive']);
        } else if (f.activeInactive === '1') {
          this.router.navigate(['tryoutprogram/active']);
        } else if (f.activeInactive === '2') {
          this.router.navigate(['tryoutprogram/archive']);
        }
      });
    } else {
      this.validateUi();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-programs/tryout-program-update/tryout-program-update.component.ts